import { SelectOption } from '../interfaces/select-option.interface';

export enum eTimeUnits {
  SECOND = 1,
  MINUTE = eTimeUnits.SECOND * 60,
  HOUR = eTimeUnits.MINUTE * 60,
  DAY = eTimeUnits.HOUR * 24,
}

export const TIME_UNITS: SelectOption<eTimeUnits>[] = [
  {
    label: 'דקות',
    value: eTimeUnits.MINUTE,
  },
  {
    label: 'שעות',
    value: eTimeUnits.HOUR,
  },
  {
    label: 'ימים',
    value: eTimeUnits.HOUR,
  },
];
